import { render } from "./Portraits.vue?vue&type=template&id=30d0c9ce"
import script from "./Portraits.vue?vue&type=script&lang=js"
export * from "./Portraits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__